// extracted by mini-css-extract-plugin
export default {"zoomModal":"a1-z"};